import {ASSET_URL, FALLBACK_IMAGE} from '~/assets/js/constants'

export const useAssetImage = (categories) => {
  // Get the base asset URL from runtime config or fallback constant
  const url = useRuntimeConfig().public.ASSET_URL || ASSET_URL

  const addAssetUrlPartIfNeeded = (asset) => {
    if (asset.startsWith('http')) {
      return asset
    }
    return url + asset
  }

  const getImageFromItem = (item, isProduct) => {
    let asset = null

    // When item is an object (product or category)
    if (typeof item === 'object' && item !== null) {
      // Product: use designSketch if available
      if (isProduct && item.designSketch && item.designSketch !== '') {
        asset = item.designSketch
        return asset
      }
      // Category: check DesignSketch property first
      else if (item.DesignSketch) {
        asset = item.DesignSketch
        return asset
      }
      // Category: fallback to DesignSketchAssetURI if not a product
      else if (!isProduct && item.DesignSketchAssetURI && item.DesignSketchAssetURI !== '') {
        asset = item.DesignSketchAssetURI
        return asset
      }
    }
    // When item is a string, search in categories by TechnicalName
    else if (typeof item === 'string' && categories && Array.isArray(categories.value)) {
      const category = categories.value.find(c => c.TechnicalName === item)
      if (category) {
        asset = category.DesignSketch || category.DesignSketchAssetURI
      }
    }

    // For experimental search when asset is still null, search by primaryL2Category
    if (
      asset === null &&
      typeof item === 'object' &&
      categories &&
      Array.isArray(categories.value)
    ) {
      const category = categories.value.find(
        c => c.TechnicalName === item.primaryL2Category
      )
      if (category) {
        asset = category.DesignSketch || category.DesignSketchAssetURI
      }
    }
    return asset
  }

  const imageUrl = (item, isProduct = false) => {
    const asset = getImageFromItem(item, isProduct)
    return asset
      ? typeof asset === 'string'
        ? addAssetUrlPartIfNeeded(asset)
        : asset.url
      : FALLBACK_IMAGE
  }

  const installationImageUrl = (item, isProduct = false) => {
    let asset = null
    if (isProduct) {
      if (item && item.designInstallationSketch && item.designInstallationSketch !== '') {
        asset = item.designInstallationSketch
      }
    } else {
      if (item && item.InstallationSketch) {
        asset = item.InstallationSketch
      } else if (item && item.InstallationSketchAssetURI && item.InstallationSketchAssetURI !== '') {
        asset = item.InstallationSketchAssetURI
      }
    }
    return asset
      ? typeof asset === 'string'
        ? addAssetUrlPartIfNeeded(asset)
        : asset.url
      : FALLBACK_IMAGE
  }

  return {
    addAssetUrlPartIfNeeded,
    getImageFromItem,
    imageUrl,
    installationImageUrl
  }
}
